import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';

import { Button } from '@components/button';

import { usePermissions } from 'features/permissions';
import { useStore } from 'models/Provider';

export function PromoteCreateButton() {
  const { t } = useStore();
  const { hasRolePermission } = usePermissions();
  if (!hasRolePermission('jobboards:manage')) return null;

  const el = document.getElementById('job-promote-actions');
  if (!el) return null;

  return createPortal(
    <Link to="new">
      <Button text={t('jobboards.create')} />
    </Link>,
    el
  );
}
